import { useTranslation } from 'react-i18next';
import { Anchor, TextCutter } from '@anytag/shared-atoms';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { useGenerateInfluencerProfileLink, usePostDetailsParam } from '@anytag/shared-hooks';
import { Post } from './Post';
import { PostReportRowData } from './types';

interface InfluencerPostProps {
  isEngagement?: boolean;
  influencerInfo: Required<Pick<PostReportRowData, 'influencerInfo'>>['influencerInfo'];
}

export const InfluencerPost = ({
  isEngagement,
  influencerInfo: { id, name, thumbNail, postLength, firstPost }
}: InfluencerPostProps) => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();
  const { generateProfileLink } = useGenerateInfluencerProfileLink();

  return (
    <div className="flex flex-4 items-center justify-between gap-2">
      <Anchor className="flex flex-4 items-center gap-2" {...generateProfileLink(id)}>
        <InfluencerAvatar size="48px" src={thumbNail} className="rounded-sm border border-border" asChild />
        <TextCutter lines={2} className="text-base" text={name || '-'} />
      </Anchor>

      {postLength > 1 ? (
        <span className="flex-6 text-right text-base">
          <b>{postLength}</b>&nbsp;
          <span className="text-xxs uppercase">{t('Post')}</span>
        </span>
      ) : firstPost ? (
        <Post
          url={firstPost.postUrl}
          content={firstPost.content}
          isEngagement={isEngagement}
          socialMedia={firstPost.socialMedia}
          thumbNail={firstPost.thumbNail || ''}
          hasTrafficSource={!!firstPost.hasTrafficSource}
          onClickPost={() => setPostDetailsParam(firstPost.id)}
        />
      ) : null}
    </div>
  );
};
